export const rtlLangs = {
  ur: {
    name: 'Urdu',
    nativeName: 'اردو',
  },
  he: {
    name: 'Hebrew',
    nativeName: 'עברית',
  },
  ar: {
    name: 'Arabic',
    nativeName: 'العربية',
  },
};

export const isRTL = langCode => {
  return !!rtlLangs[langCode];
};
